<template>
    <v-overlay
            :absolute="false"
            :opacity="0.5"
            :value="overlay"
            :z-index="5"
    >
        <v-alert :type="type">
            {{text}}
        </v-alert>
    </v-overlay>
</template>

<script>
    import {accountService} from "../services/accountService";

    export default {
        name: "EmailVerified",
        data: () => ({
            overlay: true,
            type: "",
            text: "",
        }),
        created() {
            if(!this.$route.query.token) {
                this.type = "error";
                this.text = "Kein Token angegeben";
                return;
            }

            let self = this;

            accountService.verifyEmail(this.$route.query.token).then(() => {
                self.type = "success";
                self.text = "Email wurde verifiziert.";
            }).catch((error) => {
                console.log(error);
                self.type = "error";
                self.text = error;
            })
        }
    }
</script>

<style scoped>

</style>